// src/pages/MediaKitPublicPage.jsx
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { mediaKitApi } from '../services/mediaKitApi';
import MediaKitRenderer from '../components/mediaKit/MediaKitRenderer';

export default function MediaKitPublicPage() {
    const { slug } = useParams();
    const [state, setState] = useState({ loading: true, kit: null, videos: [], error: null });

    useEffect(() => {
        mediaKitApi.getPublic(slug)
            .then(({ kit, videos }) => setState({ loading: false, kit, videos, error: null }))
            .catch(() => setState({ loading: false, kit: null, videos: [], error: 'not_found' }));
    }, [slug]);

    if (state.loading) {
        return <div className="min-h-screen flex items-center justify-center text-slate-400">Loading media kit…</div>;
    }
    if (state.error || !state.kit) {
        return (
            <div className="min-h-screen flex flex-col items-center justify-center gap-2 text-center px-4">
                <h1 className="text-2xl font-bold text-slate-800">This media kit isn't available</h1>
                <p className="text-slate-500 text-sm">It may be unpublished or the link is incorrect.</p>
            </div>
        );
    }
    return <MediaKitRenderer kit={state.kit} videos={state.videos} />;
}